// Tracks the AbortControllers of every in-flight long-running poll loop so they
// can all be cancelled at once when the user navigates away. CapacitorHttp has
// no request abort, but cancelling here stops the loop from waiting and from
// firing further poll requests for data the user no longer cares about.
const activeControllers = new Set<AbortController>();

// Creates and registers a controller for a poll loop. Pass its signal to
// pollLongRunningOperation, and call unregisterPoll(controller) once the loop
// settles (resolve, error or abort).
export const registerPoll = (): AbortController => {
  const controller = new AbortController();
  activeControllers.add(controller);
  return controller;
};

export const unregisterPoll = (controller: AbortController): void => {
  activeControllers.delete(controller);
};

// Aborts every registered poll loop. Called on navigation (URL change).
export const abortActivePolls = (): void => {
  activeControllers.forEach((controller) => controller.abort());
  activeControllers.clear();
};
